import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, Fragment } from "react";
import {TextField,
        Grid,
        InputAdornment,
        NativeSelect,
        InputLabel,
        FormControl,
        FormHelperText,
        Link
} from "@material-ui/core";
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CommentIcon from '@material-ui/icons/Comment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import MapIcon from '@material-ui/icons/Map';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import { useUserState } from "../../context/UserContext";
import Widget from '../../components/Widget';
import AddressAutoComplete from '../../components/AddressAutoComplete/AddressAutoComplete';
import SelectSiteTestingScopes from './SelectSiteTestingScopes';
import { toast } from "react-toastify";
import { sendNotification } from "../../context/UserContext";
import './Pricing.css'
import './SelectSiteTestingScopes.css'


const CreateSite = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const { onFormUpdated, onSiteUpdated, onSiteCreated } = props
    var { hourly_charge, regions, geo_regions } = useUserState(); // default hourly charge
    const classes = useStyles();
    const formRef = useRef(null);
    const [newSite, setNewSite] = useState({...props.createdSite});
    const [selectedChargeBy, setSelectedChargeBy] = useState('Tag');
    const [pricingDataDone, setPricingDataDone] = useState(false);
    const [fetchTestingScopesDataDone, setFetchTestingScopesDataDone] = useState(false);
    const [selectedRegionId, setSelectedRegionId] = useState(-1);
    const [regionOptions, setRegionOptions] = useState([]);
    const [selectedGeoRegionId, setSelectedGeoRegionId] = useState(-1);
    const [geoRegionOptions, setGeoRegionOptions] = useState([]);
    const [noRegionSelectedError, setNoRegionSelectedError] = React.useState(false);


    useImperativeHandle(ref, () => ({

    saveSite() {
        formRef.current.dispatchEvent(new Event('submit'))
      }

    }));

    useEffect(() => {
        var updatedSite = newSite;
        async function fetchPriceData() {
          const sitePricingResponse = await ttAPI.getSitePricingByCustomerId(newSite.customer_id);
          updatedSite = {
            ...updatedSite,
            single_phase_price: sitePricingResponse.single_phase_price,
            three_phase_price: sitePricingResponse.three_phase_price,
            rcd_m_price: sitePricingResponse.rcd_m_price,
            fire_price: sitePricingResponse.fire_price,
            first_aid_price: sitePricingResponse.first_aid_price,
            medical_price: sitePricingResponse.medical_price,
            rcd_pb_price: sitePricingResponse.rcd_pb_price,
            lg_pb_price: sitePricingResponse.lg_pb_price,
            lg_m_price: sitePricingResponse.lg_m_price,
            three_phase_rcd_price: sitePricingResponse.three_phase_rcd_price,
            microwave_price: sitePricingResponse.microwave_price,
            non_electrical_price: sitePricingResponse.non_electrical_price,
            ladder_price: sitePricingResponse.ladder_price,
            aed_price: sitePricingResponse.aed_price,
            evse_price: sitePricingResponse.evse_price,
            hourly_charge: sitePricingResponse.hourly_charge,
            min_charge: sitePricingResponse.min_charge,
            local_travel: sitePricingResponse.local_travel,
            seventy_hundred_travel: sitePricingResponse.seventy_hundred_travel,
            over_100_travel: sitePricingResponse.over_100_travel,
            min_cash_charge: sitePricingResponse.min_cash_charge
          };
          //console.log(sitePricingResponse)
          //console.log(updatedSite);
          fetchTestingScopesData();
          setPricingDataDone(true);
        }

        async function fetchTestingScopesData() {
          const siteTestingScopesByCustomerIdResponse = await ttAPI.getSiteTestingScopesByCustomerId(newSite.customer_id);
          console.log(siteTestingScopesByCustomerIdResponse);
          if (siteTestingScopesByCustomerIdResponse !== null && siteTestingScopesByCustomerIdResponse !== undefined &&
              siteTestingScopesByCustomerIdResponse.length >= 1) {
              var itemWithNotes = siteTestingScopesByCustomerIdResponse.filter(item => item.notes !== null && item.notes !== undefined && item.notes !== '')
              if (itemWithNotes !== null && itemWithNotes !== undefined && itemWithNotes.length > 0) {
                updatedSite = {
                  ...updatedSite,
                  testing_scope_other_notes: itemWithNotes[0].notes,
                  testing_scopes: siteTestingScopesByCustomerIdResponse
                };
              }
              else {
                  updatedSite = {
                    ...updatedSite,
                    testing_scopes: siteTestingScopesByCustomerIdResponse
                  };
              }


          }
          console.log(updatedSite);
          setNewSite(updatedSite);
          setFetchTestingScopesDataDone(true);

      }

        if (newSite.customer_id !== undefined && newSite.customer_id !== null
            && newSite.customer_id > 0) {
            fetchPriceData();
            //fetchTestingScopesData();
        }
    }, []);

     useEffect(() => {
       const callParent = (newSite) => {
         if (newSite !== undefined && newSite !== null) {
           if (newSite.name === undefined || newSite.name === null || newSite.name === '' ||
               newSite.address === undefined || newSite.address === null || newSite.address === '' ||
               newSite.franchise_id === undefined || newSite.franchise_id === null || newSite.franchise_id <= 0 ||
               (newSite.testing_scopes === undefined || newSite.testing_scopes === null || newSite.testing_scopes.length <= 0) ||
               (newSite.testing_scopes !== undefined && newSite.testing_scopes !== null && newSite.testing_scopes.length > 0 &&
                 ((newSite.testing_scopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
                   (newSite.testing_scope_other_notes== undefined || newSite.testing_scope_other_notes === null || newSite.testing_scope_other_notes === '')))) {
              onFormUpdated(false);
           }
           else {
             onFormUpdated(true);
           }
           onSiteUpdated(newSite);
           /*if (newSite.hourly_charge !== null && newSite.hourly_charge !== undefined && newSite.hourly_charge > 0) {
               setSelectedChargeBy('Hour');
           }
           else {
               setSelectedChargeBy('Tag');
           }*/
         }
       };

       callParent(newSite);
     }, [newSite]);

     useEffect(() => {
       var tempRegions = [];
       tempRegions.push(<option key="0" aria-label="None" value="" />);
       if (regions !== undefined) {
           regions.map(region => {
             if (region.id) {
               tempRegions.push(<Fragment key={region.id}><option value={region.id}>{region.name}</option></Fragment>)
             }
             return tempRegions;
           });
       }
       setRegionOptions(tempRegions);
     }, [regions]);

     useEffect(() => {
       var tempGeoRegions = [];
       tempGeoRegions.push(<option key="0" aria-label="None" value="" />);
       if (geo_regions !== undefined) {
           geo_regions.map(geo_region => {
             if (geo_region.id) {
               tempGeoRegions.push(<Fragment key={geo_region.id}><option value={geo_region.id}>{geo_region.name}</option></Fragment>)
             }
             return tempGeoRegions;
           });
       }
       setGeoRegionOptions(tempGeoRegions);
     }, [geo_regions]);

     function handleChange(e) {
       setNewSite({
         ...newSite,
         [e.target.name]: e.target.value,
       });
     }

      async function handleSubmit (e) {
         const errors = validate(newSite.name, newSite.address, newSite.franchise_id);
         if (errors.length > 0) {
             console.error('create site has error');
             return;
         }
         var siteToSave = newSite;
         if (siteToSave.testing_scopes !== undefined && siteToSave.testing_scopes !== null) {
             siteToSave.testing_scopes = siteToSave.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);
         }
         if (selectedChargeBy === 'Tag') {
             siteToSave.hourly_charge = 0;
         }
         else {
             if (siteToSave.hourly_charge === null || siteToSave.hourly_charge === undefined || siteToSave.hourly_charge <= 0) {
                 siteToSave.hourly_charge = siteToSave.default_hourly_charge;
             }
         }
         const response = await ttAPI.saveSite(siteToSave);

         if (response !== undefined && response.data !== undefined &&
             response.data[0] !== undefined) {
               if (response.data[0].ok) {
                 //sendNotification('success', newSite.id > 0 ? 'Success - Site Updated.' : 'Success - Site Created.')
                 setNewSite({
                   ...siteToSave,
                   id: response.data[0].id,
                 });;
                 onSiteCreated(newSite, newSite.id > 0, response.data[0].id);
               }
               else {
                 sendNotification('error', newSite.id > 0 ?  'Failed to update site.' : 'Failed to create site.',classes);
               }

         }
       }

       function validate(name, address, franchiseId) {
          const errors = [];
          if (name === undefined || name === null || name === '') {
            setNewSite({
              ...newSite,
              name: '',
            });
              errors.push("Name can't be empty");
          }

          if (address === undefined || address === null || address === '') {
            setNewSite({
              ...newSite,
              address: '',
            });
              errors.push("Address can't be empty");
          }

          if (franchiseId === undefined || franchiseId === null || franchiseId <= 0) {
            setNewSite({
              ...newSite,
              franchise_id: null,
            });
          errors.push("Scheduling Zone / Region can't be empty");
          }
            return errors;
        }

       function onSelectSiteAddress(address) {
         setNewSite({
           ...newSite,
           address: address
         });
       }

       function handleChangeSelectChargeBy(e) {
           setSelectedChargeBy(e.target.value);
           setNewSite({
             ...newSite,
             hourly_charge: e.target.value === 'Tag' ? 0 : hourly_charge
           });
       }

       function onTestingScopesSelected(testingScopes) {
           setNewSite({
             ...newSite,
             testing_scopes: testingScopes,
           });
       }

       function onOtherTestingScopesSpecified(otherTestingScopeNotes) {
         setNewSite({
           ...newSite,
           testing_scope_other_notes: otherTestingScopeNotes,
         });
       }

       function handleChangeRegion(e) {
         setNewSite({
           ...newSite,
           franchise_id: e.target.value === '' ? -1 : e.target.value,
         });
         setSelectedRegionId(e.target.value);
       }

       function handleChangeGeoRegion(e) {
         setNewSite({
           ...newSite,
           geo_region_id: e.target.value === '' ? -1 : e.target.value,
         });
         setSelectedGeoRegionId(e.target.value);
       }

       function onGeoLocationFetched(geolocation) {console.info('onGeoLocationFetched',geolocation)
         var geoRegion = geo_regions.find(geo_region => geolocation.region.toUpperCase() === 'Manawatu-Wanganui' ? 'Manawatū-Whanganui' === geo_region : geolocation.region.toUpperCase() === geo_region.name.toUpperCase());
         var geoRegionId = geoRegion !== undefined && geoRegion !== null ? geoRegion.id : -1;
         setSelectedGeoRegionId(geoRegionId);
         setNewSite({
           ...newSite,
           geo_region_id: geoRegionId,
           geo_locality: geolocation.locality,
           mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
         });
       }

       function onBlurRegionSelection() {
         validateRegion();
       }

       function validateRegion() {
         setNoRegionSelectedError(selectedRegionId === undefined || selectedRegionId === null || selectedRegionId <= 0);
       }

  return (
    <div className={classes.contentDiv}>
    {/*<div>{`props.createdSite is ${props.createdSite}`}</div>
    <div>{`props.createdSite.name is ${props.createdSite.name}`}</div>
    <div>{`props.createdSite.id is ${props.createdSite.id}`}</div>
    <div>{`props.createdSite.customerId is ${props.createdSite.customer_id}`}</div>
    <div>{`newSite is ${newSite}`}</div>
    <div>{`newSite.name is ${newSite.name}`}</div>
    <div>{`newSite.id is ${newSite.id}`}</div>
    <div>{`newSite.customerId is ${newSite.customer_id}`}</div>*/}

    <form
        ref={formRef}
        onSubmit={handleSubmit}>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6} sm={6}>

              <Widget
                title="Site Details"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
                noMinHeight
              >
                <div className={classes.formDisplay}>
                <TextField
                  id="name"
                  label="Name"
                  autoComplete='off'
                  onChange={handleChange}
                  name="name"
                  value={newSite.name || ''}
                  variant="outlined"
                  required
                  error={newSite.name === ''}
                  helperText={newSite.name === '' ? 'Please enter the name of the site.' : ' '}
                  size="small"
                />
                  <TextField
                    id="code"
                    label="Code"
                    autoComplete='off'
                    onChange={handleChange}
                    name="code"
                    value={newSite.code || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    size="small"
                  />
                </div>
            </Widget>

            <Widget
              title="Location"
              upperTitle
              className={classes.card}
              style={{ marginTop: 20 }}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                  <AddressAutoComplete onSelect={onSelectSiteAddress} onLocationUpdate={onGeoLocationFetched} required/>
                  <FormControl variant="outlined" style={{ marginBottom: 20}}
                                className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control': true
                                })}>
                    <InputLabel id="region">Scheduling Zone / Region<sup>*</sup></InputLabel>
                    <div className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <HomeWorkIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedRegionId}
                        onChange={handleChangeRegion}
                        onBlur={onBlurRegionSelection}
                      >
                         {regionOptions}
                      </NativeSelect>
                    </div>
                    {noRegionSelectedError && <FormHelperText className={classes.error}>You must select a scheduling zone / region for the site!</FormHelperText>}
                  </FormControl>

                  <FormControl variant="outlined" style={{ marginBottom: 20}}
                                className={classnames({
                                  'select-control': true
                                })}>
                    <InputLabel id="geo_region">Geographic Region</InputLabel>
                    <div className={classnames({
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <MapIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedGeoRegionId}
                        onChange={handleChangeGeoRegion}
                      >
                         {geoRegionOptions}
                      </NativeSelect>
                      {/*<FormHelperText>Result returned from GeoAPI: {newSite.geo_region_name}</FormHelperText>*/}
                    </div>
                  </FormControl>

                  <TextField
                      id="geo_locality"
                      label="Geographic Locality"
                      autoComplete='off'
                      onChange={handleChange}
                      name="geo_locality"
                      value={newSite.geo_locality || ''}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {newSite.mapurl !== null && newSite.mapurl !== undefined && newSite.mapurl !== '' &&
                    <Link href={newSite.mapurl} target="_blank"
                          style={{marginLeft: '10px', fontSize: '16px', textDecoration: 'underline', marginTop: '10px'}}>
                            View Map
                    </Link>}
              </div>
            </Widget>

          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <Widget
              title="Contact"
              upperTitle
              className={classes.card}
              bodyClass={classes.fullHeightBody}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="contact"
                  label="Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="contact"
                  value={newSite.contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="phone"
                  label="Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="phone"
                  value={newSite.phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="email"
                  label="Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newSite.email || ''}
                  name="email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Widget>

            <Widget
              title="Others"
              upperTitle
              className={classes.card}
              style={{ marginTop: 20 }}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                  <TextField
                    id="notes"
                    name="notes"
                    label="Notes"
                    autoComplete='off'
                    value={newSite.notes || ''}
                    multiline
                    rows="5"
                    variant="outlined"
                    onChange={handleChange}
                    style={{ marginBottom: 20 }}
                    size="small"
                    InputProps={{
                      className: classes.textarea,
                      startAdornment: (
                        <InputAdornment position="start">
                          <CommentIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className={classes.testingScopes}>
                    {pricingDataDone && fetchTestingScopesDataDone && <SelectSiteTestingScopes
                                     required={true}
                                     isAddSite={true}
                                     site={newSite}
                                     onTestingScopesSelected={onTestingScopesSelected}
                                     onOtherTestingScopesSpecified={onOtherTestingScopesSpecified}/>}
                  </div>

              </div>
            </Widget>
          </Grid>

          <Grid item xs={12} md={12} sm={12}>
              {pricingDataDone && fetchTestingScopesDataDone && <Widget
                title="Site Pricing"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
              >
                <div className={classes.pricingDisplay}>
                    <FormControl variant="outlined" className={classnames({
                          'chargeBySelect':  true,
                          'chargeby-select-control': true
                        })}>
                      <InputLabel>Charge By</InputLabel>
                      <div className={classnames({
                                    'chargeby-select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedChargeBy}
                          onChange={handleChangeSelectChargeBy}
                        >
                           <option value="Tag">Tag</option>
                           <option value="Hour">Hour</option>
                        </NativeSelect>
                      </div>
                    </FormControl>
                    {selectedChargeBy === 'Hour' && <TextField
                      id="hourlyCharge"
                      label="Hourly Charge"
                      onChange={handleChange}
                      value={newSite.hourly_charge === undefined || newSite.hourly_charge === null || newSite.hourly_charge <= 0 ? newSite.default_hourly_charge : newSite.hourly_charge}
                      name="hourly_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />}

                    <TextField
                      id="minCharge"
                      label="Min Charge"
                      onChange={handleChange}
                      value={newSite.min_charge || 0}
                      name="min_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="minCashCharge"
                      label="Min Cash Charge"
                      onChange={handleChange}
                      value={newSite.min_cash_charge || 0}
                      name="min_cash_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="localTravel"
                      label="Local Travel"
                      onChange={handleChange}
                      value={newSite.local_travel || 0}
                      name="local_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="seventyHundredTravel"
                      label="Travel 60 - 100km"
                      onChange={handleChange}
                      value={newSite.seventy_hundred_travel || 0}
                      name="seventy_hundred_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="over100Travel"
                      label="Region Travel > 100km"
                      onChange={handleChange}
                      value={newSite.over_100_travel || 0}
                      name="over_100_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    {selectedChargeBy === 'Tag' && <><TextField
                      id="singlePhasePrice"
                      label="Single Phase Price"
                      onChange={handleChange}
                      value={newSite.single_phase_price || 0}
                      name="single_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="threePhasePrice"
                      label="Three Phase Price"
                      onChange={handleChange}
                      value={newSite.three_phase_price || 0}
                      name="three_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="rcdPrice"
                      label="RCD Price"
                      onChange={handleChange}
                      value={newSite.rcd_m_price || 0}
                      name="rcd_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="firePrice"
                      label="Fire Price"
                      onChange={handleChange}
                      value={newSite.fire_price || 0}
                      name="fire_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="fistAidPrice"
                      label="First Aid Price"
                      onChange={handleChange}
                      value={newSite.first_aid_price || 0}
                      name="first_aid_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="medicalPrice"
                      label="Medical Price"
                      onChange={handleChange}
                      value={newSite.medical_price || 0}
                      name="medical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="rcdPbPrice"
                      label="RCD PB Price"
                      onChange={handleChange}
                      value={newSite.rcd_pb_price || 0}
                      name="rcd_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgPbPrice"
                      label="LG PB Price"
                      onChange={handleChange}
                      value={newSite.lg_pb_price || 0}
                      name="lg_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgMPrice"
                      label="LG6 Measured Price"
                      onChange={handleChange}
                      value={newSite.lg_m_price || 0}
                      name="lg_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="threePhaseRcdPrice"
                      label="3 Phase RCD Price"
                      onChange={handleChange}
                      value={newSite.three_phase_rcd_price || 0}
                      name="three_phase_rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="microwavePrice"
                      label="Microwave Price"
                      onChange={handleChange}
                      value={newSite.microwave_price || 0}
                      name="microwave_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="nonElectricalPrice"
                      label="Non Electrical Price"
                      onChange={handleChange}
                      value={newSite.non_electrical_price || 0}
                      name="non_electrical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="ladderPrice"
                      label="Ladder Price"
                      onChange={handleChange}
                      value={newSite.ladder_price || 0}
                      name="ladder_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="aedPrice"
                      label="AED Price"
                      onChange={handleChange}
                      value={newSite.aed_price || 0}
                      name="aed_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="evsePrice"
                      label="EVSE Price"
                      onChange={handleChange}
                      value={newSite.evse_price || 0}
                      name="evse_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    /></>}
                </div>
              </Widget> }
          </Grid>
        </Grid>

      </form>
    </div>
  );
//}
});
export default CreateSite;
